import { FormGroup, Input } from 'reactstrap'
import { setFiles } from 'store/Forms/actions'
import { dateInputTypes, headingSize, textInputTypes } from './FormFieldsData'
import {
  BottomCheckboxes,
  CheckboxOptions,
  HelpText,
  Label,
  LPPH,
  MinMaxLengthFields,
  ParagraphHeadingText,
  WidthHeight,
} from './RightSidebarComponents'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faEye } from '@fortawesome/free-solid-svg-icons'
import { clientBaseUrl } from 'utils/AxiosInstance'

const headers = Array.from({ length: 6 }, (_, index) => `H${index + 1}`)

export const renderCreateEditBody = (
  field,
  dispatch = null,
  updateFieldState = null,
  onOpenLabelModal = null
) => {
  switch (field.type) {
    case 'heading':
      return (
        <p
          style={{ fontSize: headingSize[field?.fontSize] }}
          className='border-bottom border-dark text-dark'
        >
          {field.text}
        </p>
      )
    case 'paragraph':
      return <p>{field.text}</p>
    case 'text':
    case 'number':
    case 'textarea':
    case 'email':
    case 'date':
      return (
        <FormGroup className='ml-0 mb-0'>
          <label role='button' className='form-control-label' htmlFor='text'>
            {field.label}{' '}
            {field.required ? <span className='text-danger'>*</span> : null}
          </label>
          <Input
            key={field?.index}
            readOnly={field?.readOnly}
            disabled={field?.disabled}
            placeholder={field?.placeholder}
            defaultValue={field?.value}
            id='text'
            type={
              field.inputType
                ? field.inputType
                : field.type === 'number'
                ? 'number'
                : field.type === 'text'
                ? 'text'
                : field.type === 'date'
                ? 'date'
                : 'textarea'
            }
            style={{
              height: field.type === 'textarea' ? 'auto' : '38px',
              resize: 'vertical',
            }}
            name='text'
            role='button'
            rows={field?.rows}
          />
          {field.helpText ? (
            <p style={{ fontSize: '14px' }}>{field.helpText}</p>
          ) : null}
        </FormGroup>
      )
    case 'checkbox':
    case 'radio':
      return (
        <div className='d-flex flex-column' style={{ gap: '0.5rem' }}>
          <label role='button' className='form-control-label' htmlFor='text'>
            {field.label}{' '}
            {field.required ? <span className='text-danger'>*</span> : null}
          </label>
          {field?.options?.map((option, index) => (
            <>
              {field.type === 'checkbox' ? (
                <div
                  className='custom-control custom-checkbox'
                  style={{ zIndex: '0' }}
                >
                  <input
                    className='custom-control-input'
                    id={`${field.index}${index}`}
                    type='checkbox'
                    checked={option.checked}
                    disabled={field?.disabled}
                  />
                  <label
                    className='custom-control-label'
                    htmlFor={`${field.index}${index}`}
                  >
                    {option.label}
                  </label>
                </div>
              ) : (
                <div
                  className='d-flex align-items-center'
                  style={{ zIndex: 0 }}
                >
                  <input
                    id={`radio-${option.label}`}
                    type='radio'
                    checked={option.checked}
                    style={{ marginRight: '0.5rem' }}
                  />
                  <label htmlFor={`radio-${option.label}`} className='mb-0'>
                    {option.label}
                  </label>
                </div>
              )}
            </>
          ))}
          {field.helpText ? (
            <p style={{ fontSize: '14px' }}>{field.helpText}</p>
          ) : null}
        </div>
      )
    case 'select':
      return (
        <FormGroup className='ml-0 mb-0'>
          <label role='button' className='form-control-label' htmlFor='select'>
            {field.label}{' '}
            {field.required ? <span className='text-danger'>*</span> : null}
          </label>
          <Input
            key={field?.index}
            id='select'
            type='select'
            name='select'
            style={{ height: '38px' }}
            onMouseDown={(e) => e.preventDefault()}
            disabled={field?.disabled}
            readOnly={field?.readOnly}
          >
            {field?.options?.map((option) => (
              <option key={option} value={option}>
                {option?.label}
              </option>
            ))}
          </Input>

          {field.helpText ? (
            <p style={{ fontSize: '14px' }}>{field.helpText}</p>
          ) : null}
        </FormGroup>
      )
    case 'upload':
      if (field.inputType === 'attach') {
        // Admin file upload - show file input for uploading
        return (
          <FormGroup className='ml-0 mb-0'>
            <div className='d-flex align-items-center mb-2'>
              <label role='button' className='form-control-label mb-0'>
                {field.label}{' '}
                {field.required ? <span className='text-danger'>*</span> : null}
              </label>
              <button
                type='button'
                className='btn btn-sm btn-outline-secondary ml-3'
                onClick={() => {
                  if (onOpenLabelModal) {
                    onOpenLabelModal(field)
                  }
                }}
              >
                Change Label
              </button>
            </div>
            <Input
              type='file'
              accept={field.accept}
              style={{ height: '38px' }}
              onChange={(e) => {
                console.log('leart176 - onChange triggered')
                const file = e.target.files[0]
                console.log('File selected:', file)

                if (file) {
                  console.log('File details:', file.name, file.size)

                  if (dispatch && updateFieldState) {
                    // Immediately update field state for instant UI feedback
                    const updates = {
                      selectedFileName: file.name,
                      selectedFileSize: `${(file.size / 1024).toFixed(1)} KB`,
                    }
                    console.log('Updating field state:', updates)
                    updateFieldState(field.index, updates)

                    // Add file to Redux state with field index (this will replace any existing file for this field)
                    const fileData = {
                      file: file,
                      fieldIndex: field.index,
                    }
                    console.log('Dispatching file data:', fileData)
                    dispatch(setFiles(fileData))
                  }
                }
              }}
            />
            {/* Show selected file name if available */}

            {field.selectedFileName && (
              <div
                className='mt-2 p-2 border rounded'
                style={{ backgroundColor: '#f8f9fa' }}
              >
                {field?.fileUrl ? (
                  <>
                    <button
                      onClick={() => {
                        window.open(field?.fileUrl, '_blank')
                      }}
                      className='btn btn-info py-1 mr-3'
                    >
                      View <FontAwesomeIcon icon={faEye} />
                    </button>
                    <button
                      onClick={() => {
                        console.log('Download clicked, field:', field)
                        if (!field?.fileUrl) {
                          alert('No file URL available for download')
                          return
                        }

                        const url = clientBaseUrl()
                        const fileUrl = encodeURIComponent(field?.fileUrl)
                        const proxyUrl = `${url}forms/proxy-file?url=${fileUrl}`

                        const link = document.createElement('a')
                        link.href = proxyUrl
                        link.download = 'downloaded-file' // 👈 force filename
                        document.body.appendChild(link)
                        link.click()
                        document.body.removeChild(link)
                      }}
                      className='btn btn-success py-1 mr-3'
                    >
                      Download <FontAwesomeIcon icon={faDownload} />
                    </button>
                  </>
                ) : null}
                <small className='text-success'>
                  <strong>Selected:</strong> {field.selectedFileName} (
                  {field.selectedFileSize})
                </small>
              </div>
            )}
            {field.helpText ? (
              <p style={{ fontSize: '14px' }}>{field.helpText}</p>
            ) : null}
          </FormGroup>
        )
      } else {
        // Regular file upload for users
        return (
          <FormGroup className='ml-0 mb-0'>
            <label
              role='button'
              className='form-control-label'
              htmlFor='upload'
            >
              {field.label}{' '}
              {field.required ? <span className='text-danger'>*</span> : null}
            </label>
            <Input
              key={field?.index}
              readOnly={field?.readOnly}
              disabled={field?.disabled}
              accept={field?.accept}
              id='upload'
              type='file'
              name='upload'
              role='button'
              onClick={(e) => e.preventDefault()}
            />
            {field.helpText ? (
              <p style={{ fontSize: '14px' }}>{field.helpText}</p>
            ) : null}
          </FormGroup>
        )
      }
    case 'signature':
      return (
        <>
          <label role='button' className='form-control-label'>
            {field.label}
          </label>
          <div
            style={{
              width: `${field.width}px`,
              height: `${field.height}px`,
              borderBottom: '1px dotted black',
            }}
          ></div>
          {field.helpText ? (
            <p style={{ fontSize: '14px' }}>{field.helpText}</p>
          ) : null}
        </>
      )
    // case 'spacer':
    //   return (
    //     <div
    //       className='d-flex align-items-center px-3'
    //       style={{ height: `${field.height}px`, border: '1px dotted black' }}
    //     >
    //       Spacer (text and border won't be shown in submissions)
    //     </div>
    //   )
    default:
      return <span>{field.label}</span>
  }
}

export const renderRightSidebarBody = (
  field,
  handleChange,
  updateFieldValue
) => {
  switch (field.type) {
    case 'heading':
      return (
        <>
          <ParagraphHeadingText handleChange={handleChange} field={field} />
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='type'>
              Type
            </label>
            <Input
              key={field?.index}
              id='type'
              type='select'
              name='type'
              defaultValue={field?.fontSize}
              style={{ height: '38px' }}
              onChange={(e) => handleChange('fontSize', e.target.value)}
            >
              {headers?.map((header) => (
                <option key={header} value={header}>
                  {header}
                </option>
              ))}
            </Input>
          </FormGroup>
        </>
      )
    case 'paragraph':
      return <ParagraphHeadingText handleChange={handleChange} field={field} />
    case 'text':
    case 'email':
      return (
        <>
          {field.type !== 'email' && (
            <FormGroup className='ml-0'>
              <label className='form-control-label' htmlFor='inputType'>
                Input Type
              </label>
              <Input
                key={field?.index}
                id='inputType'
                type='select'
                name='inputType'
                defaultValue={field?.inputType}
                style={{ height: '38px' }}
                onChange={(e) => handleChange('inputType', e.target.value)}
                className='text-capitalize'
              >
                {textInputTypes?.map((inputType) => (
                  <option
                    key={inputType}
                    value={inputType}
                    className='text-capitalize'
                  >
                    {inputType}
                  </option>
                ))}
              </Input>
            </FormGroup>
          )}
          <LPPH handleChange={handleChange} field={field} />
          <MinMaxLengthFields handleChange={handleChange} field={field} />
          <BottomCheckboxes
            key={field?.index}
            field={field}
            handleChange={handleChange}
          />
        </>
      )
    case 'date':
      return (
        <>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='dateType'>
              Input Type
            </label>
            <Input
              key={field?.index}
              id='dateType'
              type='select'
              name='dateType'
              defaultValue={field?.inputType}
              style={{ height: '38px' }}
              onChange={(e) => handleChange('inputType', e.target.value)}
              className='text-capitalize'
            >
              {dateInputTypes?.map((dateType) => (
                <option
                  key={dateType}
                  value={dateType}
                  className='text-capitalize'
                >
                  {dateType}
                </option>
              ))}
            </Input>
          </FormGroup>
          <LPPH handleChange={handleChange} field={field} />
          <BottomCheckboxes
            key={field?.index}
            field={field}
            handleChange={handleChange}
          />
        </>
      )
    case 'number':
      return (
        <>
          <LPPH handleChange={handleChange} field={field} />
          <MinMaxLengthFields
            handleChange={handleChange}
            field={field}
            label='number'
          />
          <BottomCheckboxes
            key={field?.index}
            field={field}
            handleChange={handleChange}
          />
        </>
      )
    case 'textarea':
      return (
        <>
          <LPPH handleChange={handleChange} field={field} />
          <MinMaxLengthFields handleChange={handleChange} field={field} />
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='fieldSize'>
              Field Size
            </label>
            <Input
              key={field?.index}
              id='fieldSize'
              type='number'
              name='fieldSize'
              defaultValue={field?.rows}
              style={{ height: '38px' }}
              onChange={(e) => handleChange('rows', e.target.value)}
            />
          </FormGroup>
          <BottomCheckboxes
            key={field?.index}
            field={field}
            handleChange={handleChange}
          />
        </>
      )
    case 'checkbox':
    case 'radio':
    case 'select':
      return (
        <>
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='label'>
              Label
            </label>
            <Input
              key={field?.index}
              id='label'
              type='label'
              name='label'
              defaultValue={field?.label}
              style={{ height: '38px' }}
              onChange={(e) => handleChange('label', e.target.value)}
            />
          </FormGroup>
          <CheckboxOptions handleChange={handleChange} field={field} />
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='help'>
              Help Text
            </label>
            <Input
              key={field?.index}
              id='help'
              type='help'
              name='help'
              defaultValue={field?.helpText}
              style={{ height: '38px' }}
              onChange={(e) => handleChange('helpText', e.target.value)}
            />
          </FormGroup>
          <BottomCheckboxes
            key={field?.index}
            field={field}
            handleChange={handleChange}
          />
        </>
      )
    case 'upload':
      // For attach file fields, show no configuration options
      if (field.inputType === 'attach') {
        return (
          <div className='text-center p-4'>
            <p className='text-muted'>This is an admin-attached file field.</p>
            <p className='text-muted'>No configuration options available.</p>
          </div>
        )
      }
      // For regular upload fields, show normal options
      return (
        <>
          <Label field={field} handleChange={handleChange} />
          <FormGroup className='ml-0'>
            <label className='form-control-label' htmlFor='accept'>
              Accept
            </label>
            <Input
              key={field?.index}
              id='accept'
              type='text'
              name='accept'
              defaultValue={field?.accept}
              style={{ height: '38px' }}
              onChange={(e) => handleChange('accept', e.target.value)}
            />
          </FormGroup>
          <HelpText field={field} handleChange={handleChange} />
          <BottomCheckboxes
            key={field?.index}
            field={field}
            handleChange={handleChange}
          />
        </>
      )
    case 'signature':
      return (
        <>
          <Label field={field} handleChange={handleChange} />
          <HelpText field={field} handleChange={handleChange} />
          <WidthHeight field={field} handleChange={handleChange} type='width' />
          <WidthHeight
            field={field}
            handleChange={handleChange}
            type='height'
          />
        </>
      )
    // case 'spacer':
    //   return (
    //     <WidthHeight field={field} handleChange={handleChange} type='height' />
    //   )
    // case 'matrix':
    //   return (
    //     <>
    //       <Label handleChange={handleChange} field={field} />
    //     </>
    //   )
    default:
      return null
  }
}
